import React, { useState } from "react";
import cn from "classnames";
import { m } from "framer-motion";
import PostCarousel from "./post-carousel";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
export default function BlogListing({ blogCategories, totalBlogs }) {
  const [activeCategory, setActiveCategory] = useState("All Blogs");
  const breakpoints = {
    1280: {
      //   slidesPerView: 2.4,
      //   spaceBetween: 30,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 64,
    },
    991: {
      //   slidesPerView: 2.2,
      //   spaceBetween: 20,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 64,
    },
    // when window width is >= 768px
    768: {
      //   slidesPerView: 1.4,
      //   spaceBetween: 20,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 64,
    },
    325: {
      //   slidesPerView: 1.1,
      //   spaceBetween: 15,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  };
  return (
    <>
      <div className="w-full bg-[#E9E7DE] md:pl-8 pl-4 pt-8">
        <div className="bg-[#E9E7DE] tagSlider flex flex-row overflow-x-auto gap-8 w-full no-scrollbar py-6 ">
          <Carousel
            slidesPerView={"auto"}
            spaceBetween={30}
            loop={false}
            className="w-full my-8"
            // breakpoints={breakpoints}
            navigation={false}
            // autoplay={{
            //   delay: 4500,
            //   disableOnInteraction: false,
            // }}
            pagination={false}
            showNavAbove={false}
            freeMode={true}
            mousewheel={{
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true,
            }}
            slidesOffsetAfter={20}
          >
            <SwiperSlide>
              <Tab
                title={"All Blogs"}
                total={totalBlogs}
                onClick={() => setActiveCategory("All Blogs")}
                activeCategory={activeCategory}
              />
            </SwiperSlide>
            {blogCategories?.map((category, key) => (
              <SwiperSlide key={"tag" + key}>
                <Tab
                  title={category?.name}
                  total={category?.blogs?.data?.length}
                  activeCategory={activeCategory}
                  setActiveCategory={setActiveCategory}
                  onClick={() => setActiveCategory(category?.name)}
                />
              </SwiperSlide>
            ))}
          </Carousel>
        </div>
      </div>
      <div className="w-full mx-auto md:px-4 bg-[#E9E7DE]">
        <div className="border-b-[0.5px] border-darkGrey/50"></div>
      </div>
      <div className="bg-[#E9E7DE] w-full lg:pb-20 pb-12 pt-8">
        <PostCarousel activeCategory={activeCategory} />
      </div>
    </>
  );
}
export const Tab = ({ title, activeCategory, onClick, total }) => {
  return (
    <div
      className="flex flex-col items-center justify-center w-fit cursor-pointer relative pt-4 shrink-0"
      onClick={onClick}
    >
      {activeCategory == title && (
        <m.div
          initial={{ y: 20, opacity: 0 }}
          animate={{
            y: activeCategory == title ? 0 : 20,
            opacity: activeCategory == title ? 100 : 0,
          }}
          transition={{ duration: 0.3 }}
          className="absolute -top-0 left-0 text-darkGrey text-sm"
        >
          ({total})
        </m.div>
      )}

      <p
        className={cn(
          "font-havletica lg:text-lg md:text-base text-sm transition-all duration-300 ease hover:text-darkGrey",
          {
            "text-darkGrey": activeCategory == title,
            "text-[#292929]/70": activeCategory != title,
          }
        )}
      >
        {title}
      </p>

      <m.div
        initial={{ width: 0 }}
        animate={{ width: activeCategory == title ? "100%" : 0 }}
        transition={{ duration: 0.3 }}
        className="bg-darkGrey h-[1px] mt-1 w-0 bottom-0"
      />
    </div>
  );
};
